export enum AppProfile {
  Aplication = 'Aplicación',
  Administrator = 'Administrador',
  Client = 'Cliente',
  Employee = 'Empleado'
}
